import { message } from "antd";
import axiosInstance from "../../../helpers/axios";
import { responseDataFormate } from "../../../helpers/bycrypt";

export interface CreatedLNFilterParams {
  page?: number;
  limit?: number;
  search?: string;
  order?: string | null;
  customer_id?: string;
  company_name?: string;
  status?: string;
}

interface GetListParams {
  filters: CreatedLNFilterParams;
  onSuccess?: (data: any) => void;
  onError?: () => void;
  signal?: AbortSignal;
}

export const getCreatedLoadNoticeAPI =
  ({ filters, onSuccess, onError, signal }: GetListParams) =>
    async (dispatch: any) => {
      try {
        const response = await axiosInstance.get("/created-load-notice", {
          params: filters,
          signal,
        });

        let result = responseDataFormate(response.data);

        if (result?.success) {
          onSuccess?.(result.data);
        } else {
          message.error(result?.message || "Failed to fetch Sub-Admins");
          onError?.();
        }
      } catch (error: any) {
        if (error.code === "ERR_CANCELED" || error.name === "AbortError") return;
        console.error("Get Sub-Admin List Error:", error);
        message.error(error?.response?.data?.message || "Unable to fetch data");
        onError?.();
      }
    };


interface UpdateLoadNoticeParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const updateLoadNoticeAPI =
  ({ payload, onSuccess, onError }: UpdateLoadNoticeParams) =>
    async (dispatch: any) => {
      try {
        const response = await axiosInstance.put(
          `/created-load-notice`,
          payload,
        );

        let result = responseDataFormate(response.data);

        if (result?.success) {
          message.success(result?.message);
          onSuccess?.(result.data);
        } else {
          message.error(result?.message);
          onError?.();
        }
      } catch (error: any) {
        console.error("Update Load Notice error:", error);
        onError?.();

        const errorMessage =
          error?.response?.data?.message || "Unable to update load notice";
        message.error(errorMessage);
      }
    };


interface DeleteLoadNoticeParams {
  id: string;
  onSuccess: () => void;
  onError: () => void;
}

export const deleteLoadNoticeAPI =
  ({ id, onSuccess, onError }: DeleteLoadNoticeParams) =>
    async (dispatch: any) => {
      try {
        const response = await axiosInstance.delete(
          `/created-load-notice`,
          {
            data: { id: id },
          },
        );

        let result = responseDataFormate(response.data);

        if (result?.success) {
          message.success(result?.message);
          onSuccess?.();
        } else {
          message.error(result?.message);
          onError?.();
        }
      } catch (error: any) {
        console.error("Delete Load Notice error:", error);
        onError?.();

        const errorMessage =
          error?.response?.data?.message;
        message.error(errorMessage);
      }
    };

